export default __webpack_public_path__ + "static/media/better-offer.b7ba7117.svg";